import * as React from 'react';
import { ReactNode } from 'react';
import { Button } from 'primereact/button';
import { IntlShape, useIntl } from 'react-intl';

interface Props {
  separator?: ReactNode | string;
  children: ReactNode | ReactNode[];
  limits?: number;
  initialShow?: boolean;
  breakpoint?: 'xl' | 'lg' | 'md' | 'sm' | 'always';
}

export const BreakingList: React.FC<Props> = (props: Props): ReactNode => {
  const intl: IntlShape = useIntl();
  const [limit, setLimit] = React.useState<boolean>(props.limits && !props.initialShow);

  const children: ReactNode[] = (Array.isArray(props.children) ? props.children : [props.children]).filter(Boolean);
  const separator: ReactNode = props.separator ?? ', ';
  const breakPoint: 'xl' | 'lg' | 'md' | 'sm' | 'always' = props.breakpoint || 'md';
  const prefix: string = breakPoint === 'always' ? '' : `${breakPoint}:`;
  return <div className={`flex flex-column ${prefix}flex-row column-gap-1 row-gap-0 flex-wrap `}>
    {children
      .slice(0, limit && props.limits ? props.limits : children.length)
      .map((child: ReactNode, index: number, array: ReactNode[]): ReactNode => {
        return <div key={index} className={'flex mb-1'}>
          {child}
          {index + 1 < array.length && <span className={`hidden ${prefix}inline`}>{separator}</span>}</div>;
      })}
    {props.limits && props.limits < children.length &&
      <Button
        size={'small'}
        pt={{root: {className: 'p-0'}}}
        text
        onClick={(): void => {
          setLimit((value: boolean): boolean => !value);
        }}
      >
        {limit ? intl.formatMessage({id: 'button.more'}) : intl.formatMessage({id: 'button.less'})}
      </Button>
    }
  </div>;
};
